
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"2 2 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M23.391 16.675a1.167 1.167 0 00-1.65 0l-3.316 3.316a1.167 1.167 0 00-.342.826v2.516H20.6c.31 0 .606-.123.825-.341l3.317-3.317a1.167 1.167 0 000-1.65l-1.35-1.35z"}}),_c('circle',{attrs:{"cx":"14","cy":"11.083","r":"2.917"}}),_c('path',{attrs:{"d":"M16.333 16.917H11.42a2.914 2.914 0 00-2.67 1.75M14 24.5a10.5 10.5 0 1110.383-11.667"}})])
          )
        }
      }
    